import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
export function usePreferredPlatform() {
    const preferredPlatform = usePreferredPlatformToken();
    return preferredPlatform === null || preferredPlatform === void 0 ? void 0 : preferredPlatform.platform;
}
export function usePreferredPlatformToken() {
    const { tokens } = useUserCreatorData();
    return tokens === null || tokens === void 0 ? void 0 : tokens.find(token => token.isPreferred);
}
